/*
 * @Author: wzh
 * @LastEditTime: 2023-04-04 17:26:11
 * @Description: 入口文件
 */

import Vue from "vue";
import config from "@/config";

import "vant/lib/index.css";
// 导入所有全局样式文件（保证所有全局样式在组件样式之前，需要在 App.vue 之前导入）
import "@/assets/scss";

import { registerPlugins } from "@/plugins";
import { registerDirectives } from "@/directives";
import { registerFilters } from "@/filters";
import { registerEventBus } from "@/utils/event-bus";
import { hydrateRememberMeFromCookie } from "@/utils/rememberMe";
import { hydrateAuthFromCookies } from "@/utils/authSession";

import router from "@/router";
import store from "@/store";
import App from "@/App.vue";

// 是否启用Mock数据
if (config.ENVS.IS_DEV && config.SERVICES.MOCK_ENABLE) {
	require("../mock");
}

Vue.config.productionTip = false;

// 注册所有插件
registerPlugins(Vue);
// 注册全局指令
registerDirectives(Vue);
// 注册全局过滤器
registerFilters(Vue);
// 注册 EventBus
registerEventBus();

// 滑块验证
import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(SlideVerify);

// cookies（须先于读取 REMEMBER_ME 的 hydrate）
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// 7 天免登录优先恢复，再同步普通会话 Cookie（免登录时不覆盖 token）
hydrateRememberMeFromCookie(store, VueCookies);
hydrateAuthFromCookies(VueCookies);

// 语言国际化
import i18n from "./lang";

// 移动端调试工具
import Vconsole from "vconsole";
if (window.ipConfigUrl.vConsoleShow) {
	let vConsole = new Vconsole();
	Vue.use(vConsole);
}

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount("#app");
